module.exports = "<h2>이용가이드</h2>\n\n<div class=\"guide-detail\">\n  <div *ngIf=\"!!guide\" class=\"board\">\n    <h3 class=\"guide-detail-title\">{{guide.title}}</h3>\n    <div class=\"guide-detail-content ql-editor\" content-outlink [innerHtml]=\"guide.content | safeHtml\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/member/guide/guide-detail/guide-detail.component.html
// module id = 1100
// module chunks = 0